<template>
  <div class="text-center">
    <div class="inline-block">
        <span class="font-bold">{{$t("Labels.Time")}}</span>
        <vs-input-number :min="min" v-model="timeEdit" :max="max" class="text-xs"/>
    </div>
    <div  class="inline-block ml-5">
      <span class="font-bold">{{$t("Labels.TimeUnity")}}</span>
      <v-select :options="timeOptions" v-model="unityEdit"  :clearable="false"/>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
const mins = {
  seconds: 14400,
  minutes: 240,
  hours: 4
}

const maxs = {
  seconds: 86400,
  minutes: 1440,
  hours: 24
}

export default {
  components: {
    vSelect
  },
  props: {
    time: Number,
    unity: String
  },
  data () {
    return {
      timeEdit: 0,
      unityEdit: '',
      timeOptions: [
        { label: 'Segundos', value: 'seconds' },
        { label: 'Minutos', value: 'minutes' },
        { label: 'Horas', value: 'hours' }
      ],
      mins,
      maxs
    }
  },
  watch: {
    timeEdit (val) {
      this.$emit('time', val)
    },
    unityEdit (val) {
      if (this.timeEdit < this.mins[val.value]) { this.timeEdit = this.mins[val.value] } else if (this.timeEdit > this.maxs[val.value]) { this.timeEdit = this.maxs[val.value] }
      this.$emit('unity', val.value)
    }
  },
  computed: {
    min () {
      return this.mins[this.unityEdit.value]
    },
    max () {
      return this.maxs[this.unityEdit.value]
    }
  },
  created () {
    this.timeEdit = this.time || 0
    const app = this
    const options = {
      seconds () {
        app.unityEdit = { label: 'Segundos', value: 'seconds' }
      },
      minutes () {
        app.unityEdit = { label: 'Minutos', value: 'minutes' }
      },
      hours () {
        app.unityEdit = { label: 'Horas', value: 'hours' }
      }
    }

    options[this.unity]()
  }
}
</script>
